import ProductImage from './ProductImage';


const SWATCH_WIDTH = 32;
const JUMBO_SWATCH_WIDTH = 64;
const IMG_WIDTH = 245;
const MAX_SWATCHES = 60;

function calculateOffset(swatchCount, swatchWidth, idx) {
  return parseInt(swatchCount * swatchWidth, 10) - (idx * swatchWidth);
}

function buildColorSwatchSprite(data, idx) {
  const swatches = data.colors.colorMap;
  const swatchCount = swatches.length;
  const snbTemplateUrlRemovalattrs = data.snbTemplateUrlRemovalattrs;
  let swatchUrlTemplate;
  let swatchSize = (idx + 1) * MAX_SWATCHES;
  if (snbTemplateUrlRemovalattrs && snbTemplateUrlRemovalattrs.swatchUrlTemplate) {
    swatchUrlTemplate = `${snbTemplateUrlRemovalattrs.swatchUrlTemplate}?&$b=MCY/swatches/&layer=0&size=`;
  } else if (data.colors.urlTemplate) {
    swatchUrlTemplate = `${data.colors.urlTemplate.swatch}?&$b=MCY/swatches/&layer=0&size=`;
  }
  let swatchUrlCount = swatchCount;
  if (swatchUrlCount > MAX_SWATCHES) {
    swatchUrlCount = MAX_SWATCHES;
  }
  const countStr = `&cropN=0,0,${swatchUrlCount},1`;

  let swatchUrl = `${swatchUrlTemplate}${parseInt(swatchUrlCount * SWATCH_WIDTH, 10)},${SWATCH_WIDTH}${countStr}`;
  let jumboSwatchUrl = `${swatchUrlTemplate}${parseInt(swatchUrlCount * JUMBO_SWATCH_WIDTH, 10)},${JUMBO_SWATCH_WIDTH}${countStr}`;
  let swatchParams = '';
  let jumboSwatchParams = '';
  let val;
  let i;
  if (swatchSize > swatchCount) {
    swatchSize = swatchCount;
  }
  for (i = 0; i < swatchSize - (idx * MAX_SWATCHES); i++) {
    val = swatches[i];
    if (val && val.swatchImage && val.swatchImage.filePath) {
      const pre = `&src=is{$b$${val.swatchImage.filePath}}&anchor=0,0&layer=${i + 1}&size=`;
      const post = `&posN=${(1 / swatchUrlCount) * (i + 1)},0`;

      swatchParams += `${pre}${SWATCH_WIDTH},${SWATCH_WIDTH}${post}`;
      jumboSwatchParams += `${pre}${JUMBO_SWATCH_WIDTH},${JUMBO_SWATCH_WIDTH}${post}`;
    }
  }

  const opts = '&op_sharpen=1&fmt=jpeg&qlt=90,0&hei=';
  swatchUrl = `${swatchUrl + swatchParams}${opts}${SWATCH_WIDTH}`;
  jumboSwatchUrl = `${jumboSwatchUrl + jumboSwatchParams}${opts}${JUMBO_SWATCH_WIDTH}`;

  return {
    swatchUrl,
    jumboSwatchUrl,
    swatchSize,
  };
}

function buildColorSwatchData(data, detail, snbTemplateUrlRemovalattrs) {
  const swatches = data.colors.colorMap;
  const swatchCount = swatches.length;
  let swatchIteration = 1;
  data.snbTemplateUrlRemovalattrs = snbTemplateUrlRemovalattrs;
  const selectedSwatch = data.colors.selectedColor;
  const { flags } = detail;
  let i;
  let idx;
  let count;
  let val;
  let offsetSwatchCount = swatchCount;
  if (swatchCount > MAX_SWATCHES) {
    swatchIteration = swatchCount / MAX_SWATCHES;
    offsetSwatchCount = MAX_SWATCHES;
  }
  for (i = 0; i < swatchIteration; i++) {
    const { swatchUrl, jumboSwatchUrl, swatchSize } = buildColorSwatchSprite(data, i);
    let swatchSpriteSize = swatchSize;
    count = i * MAX_SWATCHES;
    if (count > swatchSpriteSize) {
      swatchSpriteSize = swatchCount;
    }
    for (idx = count; idx < swatchSpriteSize; idx++) {
      val = swatches[idx];
      swatches[idx].colorSwatchSprite = swatchUrl;
      if (data.swatchImageOptimizationEnabled) {
        swatches[idx].swatchImageOptimizationEnabled = data.swatchImageOptimizationEnabled;
      }
      swatches[idx].offset = calculateOffset(offsetSwatchCount, SWATCH_WIDTH, idx);
      if (val && val.imagery && val.imagery.primaryImage && val.imagery.primaryImage.filePath) {
        /*
        * Handling the error as ProductImage.buildSimpleUrl doesn't exist.
        */
        try {
          let productUrlTemplate;
          if (snbTemplateUrlRemovalattrs && snbTemplateUrlRemovalattrs.productUrlTemplate) {
            productUrlTemplate = snbTemplateUrlRemovalattrs.productUrlTemplate;
          } else if (data.colors.urlTemplate) {
            productUrlTemplate = data.colors.urlTemplate.product;
          }

          swatches[idx].preview = ProductImage.buildSimpleUrl(productUrlTemplate, val.imagery.primaryImage.filePath, IMG_WIDTH);
        } catch (e) {
          //
        }
        if (val.imagery.primaryImage.showJumboSwatch || (flags.masterProduct && !flags.hasColors)) {
          swatches[idx].jumboSwatch = jumboSwatchUrl;
          swatches[idx].jumboSwatchOffset = calculateOffset(offsetSwatchCount, JUMBO_SWATCH_WIDTH, idx);
        }
      }
      if (selectedSwatch && selectedSwatch.id && val.id && selectedSwatch.id === val.id) {
        swatches[idx].swatchSelected = true;
      }
    }
  }
  return swatches;
}

export default {
  buildColorSwatchData,
};
